module.exports = __webpack_public_path__ + "static/img/service1.72ccf7d8.png";